import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";

const PredictionIscChart = ({ chartData, loading = false }) => {
	const [state, setState] = React.useState({
		series: [{
			data: []
		}],
		options: {
			chart: {
				id: 'prediction-area-datetime',
				type: 'area',
				height: 350,
				zoom: {
					autoScaleYaxis: true
				},
				toolbar: {
					show: true,
					tools: {
						download: true,
						selection: true,
						zoom: true,
						zoomin: true,
						zoomout: true,
						pan: true,
						reset: true,
						customIcons: []
					},
					export: {
						csv: {
							filename: 'prediction-isc-data',
							columnDelimiter: ',',
							headerCategory: 'Date',
							headerValue: 'ISC (A)',
						},
						png: {
							filename: 'prediction-isc-chart',
						},
						svg: {
							filename: 'prediction-isc-chart',
						},
					}
				}
			},
			colors: ["#008FFB"],
			annotations: {
				yaxis: [{
					y: 30,
					borderColor: '#999',
					label: {
						show: true,
						text: 'Support',
						style: {
							color: "#fff",
							background: '#00E396'
						}
					}
				}],
				xaxis: [{
					x: new Date('14 Nov 2012').getTime(),
					borderColor: '#999',
					yAxisIndex: 0,
					label: {
						show: true,
						text: 'Rally',
						style: {
							color: "#fff",
							background: '#775DD0'
						}
					}
				}]
			},
			dataLabels: {
				enabled: false
			},
			markers: {
				size: 0,
				style: 'hollow',
			},
			xaxis: {
				type: 'datetime',
				tickAmount: 6,
			},
			yaxis: {
				labels: {
					formatter: function (value) {
						return value.toFixed(0);
					}
				}
			},
			tooltip: {
				x: {
					format: 'dd MMM yyyy HH:MM'
				},
				y: {
					formatter: function (value) {
						return value.toFixed(1) + ' A';
					}
				},
				style: {
					fontSize: '16px'
				}
			},
			fill: {
				type: 'gradient',
				gradient: {
					shadeIntensity: 1,
					opacityFrom: 0.3,
					opacityTo: 0.6,
					stops: [0, 100]
				}
			},
		}
	});

	useEffect(() => {
		// Use prediction chart data from the database
		if (chartData && chartData.Isc_mod) {
			console.log("Using prediction Isc_mod data:", chartData.Isc_mod);
			
			// Calculate the actual data range with small buffer
			const timestamps = chartData.Isc_mod.map(point => point[0]);
			const values = chartData.Isc_mod.map(point => point[1]);
			
			const minTime = Math.min(...timestamps);
			const maxTime = Math.max(...timestamps);
			const minValue = Math.min(...values);
			const maxValue = Math.max(...values);
			
			// Add small buffer (5% of range) around the data
			const timeRange = maxTime - minTime;
			const valueRange = maxValue - minValue;
			const timeBuffer = timeRange * 0.05; // 5% buffer
			const valueBuffer = valueRange * 0.05; // 5% buffer
			
			// Make sure data is in format: [[timestamp, value], ...]
			setState(prev => ({
				...prev,
				series: [{
					name: 'ISC (A)',
					data: chartData.Isc_mod
				}],
				options: {
					...prev.options,
					xaxis: {
						...prev.options.xaxis,
						min: minTime - timeBuffer,
						max: maxTime + timeBuffer
					},
					yaxis: {
						...prev.options.yaxis,
						min: minValue - valueBuffer,
						max: maxValue + valueBuffer
					}
				}
			}));
		}
	}, [chartData]);

	if (loading) {
		return (
			<div className="flex justify-center items-center py-20">
				<div className="text-center">
					<div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent mx-auto mb-4"></div>
					<p className="text-lg text-gray-600 font-medium">Loading chart data...</p>
				</div>
			</div>
		);
	}

	if (!chartData || !chartData.Isc_mod || chartData.Isc_mod.length === 0) {
		return (
			<div className="bg-gray-50 p-8 rounded-lg text-center">
				<p className="text-gray-600">No chart data available for this prediction</p>
			</div>
		);
	}

	return (
		<div>
			<div id="chart">
				<div id="chart-timeline">
					<ReactApexChart options={state.options} series={state.series} type="area" height={350} />
				</div>
			</div>
			<div id="html-dist"></div>
		</div>
	);
}

export default PredictionIscChart;